<div>
	{{ value | translate }}
</div>
